module.exports = __webpack_public_path__ + "fonts/Inter-200-cyrillic12.fbe36d9.woff2";